import { DateTime } from "luxon";
export default class RecRegistryAccreditationCode {
  id: string | undefined
  actionDateImported?: DateTime
  actionDateProcessed?: DateTime
  actionsForProcessingCount = 0
  actionsWithErrorsCount = 0

  constructor(obj: unknown) {
    Object.assign(this, obj)
  }
}